var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9819L2.40974 11.5579L5.60494 11.5601L3.19377 14.9819H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19434 13.5569L5.49808 14.9994L6.93445 13.0767L5.60311 11.5579L4.19434 13.5569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49707 15.0001L9.86422 9.14661H12.9269L8.79587 15.0001H5.49707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9263 9.14661L13.5684 11.6651L11.1716 14.9811L10.5166 12.5426L12.9263 9.14661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.165 14.9836L16.6032 7.43656L15.5175 6.85581L19.8772 5.00012L20.0001 9.03187L18.9881 8.56279L14.426 14.9835L11.165 14.9836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGame);
export default __webpack_public_path__ + "static/media/menu-game.00149a42a745acb28f947894d7f427d5.svg";
export { ForwardRef as ReactComponent };